import { InjectionToken } from '@angular/core';
import { KeyValueCache } from './utils/create-cache';

export const SOFTLINE_WWS_CASH_REGISTER_IMG_CACHE = new InjectionToken<
  KeyValueCache<string>
>('SOFTLINE_WWS_CASH_REGISTER_IMG_CACHE');

export const SOFTLINE_WWS_CASH_REGISTER_CATEGORIES_IMG_CACHE = new InjectionToken<
  KeyValueCache<string>
>('SOFTLINE_WWS_CASH_REGISTER_CATEGORIES_IMG_CACHE');
